import { render, staticRenderFns } from "./UserDetailsCard.vue?vue&type=template&id=cb6ac7a6&scoped=true"
import script from "./UserDetailsCard.vue?vue&type=script&lang=js"
export * from "./UserDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./UserDetailsCard.vue?vue&type=style&index=0&id=cb6ac7a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6ac7a6",
  null
  
)

export default component.exports